module.exports = __webpack_public_path__ + "static/media/agent7.0ee613db.png";